const initialState = {
    token: !!localStorage.getItem('token') ? localStorage.getItem('token') : false,
    profile: JSON.parse(localStorage.getItem('profile')) ? JSON.parse(localStorage.getItem('profile')) : {},
    activeAddress: JSON.parse(localStorage.getItem('activeAddress')) ? JSON.parse(localStorage.getItem('activeAddress')) : {},
};
const user = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_TOKEN':
            localStorage.setItem('token', action.token);
            return {...state, token: action.token};
       	case 'CHANGE_PROFILE_DATA':
            localStorage.setItem('profile', JSON.stringify(action.info));
            return {...state, profile: action.info};
        case 'SET_USER_ACTIVE_ADDRESS':
            localStorage.setItem('activeAddress', JSON.stringify(action.activeAddress));
            return {...state, activeAddress: action.activeAddress};
        case 'LOG_OUT_USER':
            localStorage.removeItem('token');
            localStorage.removeItem('profile');
            localStorage.removeItem('activeAddress');
            return {...initialState, token: false, profile: {}};
        default:
            return state;
    }
};

export default user;
